import { stylesheet, classes, style } from 'typestyle'
import { important } from 'csx'

/* Common ======================================================================================= */
import { get } from '../../../__aeki__/share/find'

/* Components =================================================================================== */
import { A } from '../../../__aeki__/components/a'
import { Box } from '../../../__aeki__/components/box/box.component'
import { Button } from '../../../__aeki__/components/button'
import { Dropdown } from '../../../__aeki__/components/dropdown'
import { Line } from '../../../__aeki__/components/line'
import { SaveButton } from './save-button'
import { Text } from '../../../__aeki__/components/text/text.component'

/* Styles ======================================================================================= */
import { b16 } from '../../../__aeki__/styles/styleset/bottom/b16'
import { createCustomMediaQuery } from '../../../__aeki__/components/style-class/style-class.utils'
import { f16i } from '../../../__aeki__/styles/styleset/font-size/f16i'
import { hide } from '../../../__aeki__/styles/styleset/hide/hide'
import { hidesmi } from '../../../__aeki__/styles/styleset/hide/hidesmi'
import { mb4 } from '../../../__aeki__/styles/styleset/margin/mb4'
import { ml8 } from '../../../__aeki__/styles/styleset/margin/ml8'
import { mr4 } from '../../../__aeki__/styles/styleset/margin/mr4'
import { mr8 } from '../../../__aeki__/styles/styleset/margin/mr8'
import { mt4 } from '../../../__aeki__/styles/styleset/margin/mt4'
import { mt8 } from '../../../__aeki__/styles/styleset/margin/mt8'
import { p4 } from '../../../__aeki__/styles/styleset/padding/p4'
import { p8 } from '../../../__aeki__/styles/styleset/padding/p8'
import { r8 } from '../../../__aeki__/styles/styleset/right/r8'
import { showsm } from '../../../__aeki__/styles/styleset/show/showsm'
import { t8 } from '../../../__aeki__/styles/styleset/top/t8'
import { z3 } from '../../../__aeki__/styles/styleset/z-index/z3'
import { f12i } from '../../../__aeki__/styles/styleset/font-size/f12i'
import { hidemd } from '../../../__aeki__/styles/styleset/hide/hidemd'
import { hidei } from '../../../__aeki__/styles/styleset/hide/hidei'
import { showsmi } from '../../../__aeki__/styles/styleset/show/showsmi'
import { flexsmi } from '../../../__aeki__/styles/styleset/flex/flexsmi'

const parseDistance = (m: number) => {
  if (m >= 1000) {
    return `${Math.round(Math.round(m / 100)) / 10}km`
  }

  return `${Math.round(m)}m`
}

const percentColors = [
  { pct: 0.0, color: { r: 157, g: 243, b: 192 } },
  { pct: 0.5, color: { r: 253, g: 248, b: 221 } },
  { pct: 1.0, color: { r: 252, g: 229, b: 218 } },
]

const getColorForPercentage = function(pct: number) {
  let position = 1
  for (let i = 1; i < percentColors.length - 1; i++) {
    if (pct < percentColors[i].pct) {
      position = i
      break
    } else {
      position = percentColors.length - 1
    }
  }
  const lower = percentColors[position - 1]
  const upper = percentColors[position]
  const range = upper.pct - lower.pct
  const rangePct = (pct - lower.pct) / range
  const pctLower = 1 - rangePct
  const pctUpper = rangePct
  const color = {
    r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
    g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
    b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper),
  }
  return 'rgb(' + [color.r, color.g, color.b].join(',') + ')'
  // or output as hex if preferred
}

/* <ChildcareCard /> ============================================================================ */
export const ChildcareCard = (props: {
  ccp: any
  index: any
  classNameImage?: string
  onClick?: any
  simplify?: boolean
  reference?: any
  refresh?: any
  focused?: boolean
  onQuickLook?: any
  onLocation?: any
  onLocationMobile?: any
  allowWatch?: boolean
  allowDelete?: boolean
  onFilter?: any
  filters?: any
  currentFilters?: any
  isMapOpen?: boolean
  highlightText?: boolean
}) => {
  const { ccp, onClick, reference, allowWatch = true, allowDelete, isMapOpen, focused } = props

  const { index } = reference || {}

  const handleCardClick = () => {
    if (onClick) {
      onClick()
    }
  }

  const handleCardMouseEnter = () => {
    const marker = document.getElementById(`google-map-marker-${index}`)

    if (marker) {
      if (marker.parentNode) {
        ;(marker.parentNode as any).style.zIndex = '5'
      }
      marker.style.backgroundColor = '#61ade2'
      marker.style.position = 'fixed'
    }
  }

  const handleCardMouseLeave = () => {
    const marker = document.getElementById(`google-map-marker-${index}`)

    if (marker) {
      marker.style.backgroundColor = ''
      if (marker.parentNode) {
        ;(marker.parentNode as any).style.zIndex = '0'
      }
    }
  }

  const name = get('body.generalInformation.name', ccp)
  const address = get('body.generalInformation.addressLine1', ccp)
  const distance = get('distance', ccp)
  const curriculum = get('body.curriculum.curriculum', ccp, 'object')
  const ageGroups = get('body.ageGroup.ageGroups', ccp, 'object')
  const languages = get('body.language.languages', ccp, 'object')
  const community = get('body.community', ccp, 'object')

  return (
    <>
      <Box spaceBetween flex>
        <Box>
          <A
            rel="noreferrer"
            title={`Go To ${name} Page`}
            to={`/a/c/${ccp?.id}`}
            target="_blank"
            onMouseEnter={handleCardMouseEnter}
            onMouseLeave={handleCardMouseLeave}
          >
            <Text
              className={classes(STYLES.textName, mt4)}
              size="md"
              crank
              disableMediaQuery
              // listLink
              link={focused}
            >
              {name}
            </Text>
          </A>
          {community?.body?.generalInformation?.name && (
            <A
              rel="noreferrer"
              title={`Go To ${name} Page`}
              to={`/a/r/${community?.id}`}
              target="_blank"
            >
              <Text className={classes(mt4)} size="sm" shrink>
                {'Resource & Referral Centre: '}
                <Text size="sm" disableMediaQuery link shrink>
                  {community.body.generalInformation.name}
                </Text>
              </Text>
            </A>
          )}
        </Box>
        <Box className={classes(b16, t8, r8, ml8)} baseline="none" column>
          <Box className={classes(hidei, flexsmi)} style={{ gap: 8 }} alignCenterY>
            {allowDelete && (
              <SaveButton
                name={name}
                id={ccp?.id}
                watched={ccp?.watched}
                refresh={props.refresh}
                isDelete={true}
                showLabel={false}
                float
              />
            )}
            {allowWatch && (
              <SaveButton
                baseline="background"
                name={name}
                id={ccp?.id}
                watched={ccp?.watched}
                refresh={props.refresh}
                showLabel={false}
              />
            )}
            <Button
              baseline="background"
              size="sm"
              icon={<span className={classes('material-icons-two-tone', f16i)}>visibility</span>}
              onClick={(event: any) => {
                event.stopPropagation()
                event.preventDefault()

                if (props.onQuickLook) {
                  props.onQuickLook()
                }

                handleCardClick()
              }}
              square
            />
          </Box>
          <Box className={hidesmi} flex alignCenterY>
            {isMapOpen ? (
              <Dropdown
                floatProps={{
                  anchorPosition: 'bottom right',
                  dialogPosition: 'top right',
                  fixed: true,
                  flip: true,
                  width: 176,
                }}
              >
                <Button
                  ariaLabel="Toggle childcare action items"
                  baseline="background"
                  size="md"
                  icon={
                    <span className={classes('material-icons-two-tone', f16i)}>more_horiz</span>
                  }
                />
                {() => {
                  return (
                    <Box
                      className={classes(p8, z3)}
                      baseline="surface"
                      minWidth={176}
                      rounded
                      shadow
                      flex
                      row
                      style={{
                        zIndex: 3,
                      }}
                    >
                      {allowDelete && (
                        <SaveButton
                          name={name}
                          id={ccp?.id}
                          watched={ccp?.watched}
                          refresh={props.refresh}
                          isDelete={true}
                          showLabel={false}
                          float
                        />
                      )}
                      {allowWatch && (
                        <SaveButton
                          baseline="background"
                          className={classes(mb4)}
                          name={name}
                          id={ccp?.id}
                          watched={ccp?.watched}
                          refresh={props.refresh}
                          showLabel={true}
                        />
                      )}
                      <Button
                        baseline="background"
                        label="Quick View"
                        size="sm"
                        icon={
                          <span className={classes('material-icons-two-tone', f16i)}>
                            visibility
                          </span>
                        }
                        onClick={(event: any) => {
                          event.stopPropagation()
                          event.preventDefault()

                          if (props.onQuickLook) {
                            props.onQuickLook()
                          }

                          handleCardClick()
                        }}
                        square
                      />
                    </Box>
                  )
                }}
              </Dropdown>
            ) : (
              <>
                {allowDelete && (
                  <SaveButton
                    baseline="background"
                    name={name}
                    id={ccp?.id}
                    className={mr4}
                    watched={ccp?.watched}
                    refresh={props.refresh}
                    isDelete={true}
                    showLabel={false}
                  />
                )}
                {allowWatch && (
                  <SaveButton
                    baseline="background"
                    className={mr4}
                    name={name}
                    id={ccp?.id}
                    watched={ccp?.watched}
                    refresh={props.refresh}
                    showLabel={false}
                    square={false}
                  />
                )}
                <Button
                  baseline="background"
                  size="sm"
                  label={isMapOpen ? '' : 'Quick View'}
                  icon={
                    <span className={classes('material-icons-two-tone', f16i)}>visibility</span>
                  }
                  onClick={(event: any) => {
                    event.stopPropagation()
                    event.preventDefault()

                    if (props.onQuickLook) {
                      props.onQuickLook()
                    }

                    handleCardClick()
                  }}
                />
              </>
            )}
          </Box>
        </Box>
      </Box>

      {!props.simplify && <Line className={classes(mt8, mb4)} dark />}
      {!props.simplify && (
        <Box baseline="none" row>
          <Box
            className={style({
              display: 'flex',
              flexWrap: 'wrap',
            })}
          >
            {distance !== undefined && (
              <Box
                className={classes(mt8, mr8, p4, STYLES.containerDistance)}
                style={{
                  background: getColorForPercentage(distance / 4000),
                }}
                rounded
                alignCenterX
                alignCenterY
              >
                <Text size="xs" shrink>
                  {parseDistance(distance)}
                </Text>
              </Box>
            )}
            <Box
              className={classes(mt8, mr8)}
              onMouseEnter={handleCardMouseEnter}
              onMouseLeave={handleCardMouseLeave}
            >
              <Box
                className={classes(
                  hide,
                  style({
                    $nest: {
                      ...createCustomMediaQuery({
                        maxWidth: 992,
                        style: {
                          display: 'flex !important',
                        },
                      }),
                    },
                  }),
                )}
              >
                <Button
                  size="xs"
                  label={address.split(',')[0]}
                  icon={
                    <span
                      className={classes(
                        focused ? 'material-icons' : 'material-icons-two-tone',
                        f12i,
                      )}
                    >
                      room
                    </span>
                  }
                  ariaLabel="Locate this childcare on the map"
                  baseline={focused ? 'primary' : 'background'}
                  onClick={(event: any) => {
                    event.stopPropagation()
                    event.preventDefault()

                    props.onLocationMobile(ccp.location.coordinates)
                  }}
                />
              </Box>
              <Box
                className={style({
                  $nest: {
                    ...createCustomMediaQuery({
                      maxWidth: 992,
                      style: {
                        display: 'none !important',
                      },
                    }),
                  },
                })}
              >
                <Button
                  className={hidemd}
                  size="xs"
                  label={address.split(',')[0]}
                  icon={
                    <span
                      className={classes(
                        focused ? 'material-icons' : 'material-icons-two-tone',
                        f12i,
                      )}
                    >
                      room
                    </span>
                  }
                  ariaLabel="Locate this childcare on the map"
                  baseline={focused ? 'primary' : 'background'}
                  onClick={(event: any) => {
                    event.stopPropagation()
                    event.preventDefault()

                    props.onLocation(ccp.location.coordinates)
                  }}
                />
              </Box>
            </Box>
            {Object.keys(ageGroups).map((key: any) => {
              return (
                <Box className={classes(mt8, mr8)} key={key}>
                  <Button
                    size="xs"
                    label={props.filters?.ageGroup.find((a: any) => a.name === key).label}
                    icon={
                      <span
                        className={classes(
                          props.currentFilters?.[`ageGroup.${key}`]
                            ? 'material-icons'
                            : 'material-icons-two-tone',
                          f12i,
                        )}
                      >
                        group
                      </span>
                    }
                    baseline={
                      props.currentFilters?.[`ageGroup.${key}`] ? 'secondary' : 'background'
                    }
                    onClick={() => {
                      props.onFilter({
                        [`ageGroup.${key}`]: props.currentFilters[`ageGroup.${key}`] ? false : true,
                      })
                    }}
                  />
                </Box>
              )
            })}
            {Object.keys(curriculum).map((key: any) => {
              return (
                <Box className={classes(mt8, mr8)} key={key}>
                  {props.filters?.curriculum.find((a: any) => a.name === key)?.label && (
                    <Button
                      size="xs"
                      label={props.filters?.curriculum.find((a: any) => a.name === key)?.label}
                      icon={
                        <span
                          className={classes(
                            props.currentFilters?.[`curriculum.${key}`]
                              ? 'material-icons'
                              : 'material-icons-two-tone',
                            f12i,
                          )}
                        >
                          school
                        </span>
                      }
                      baseline={
                        props.currentFilters?.[`curriculum.${key}`] ? 'secondary' : 'background'
                      }
                      onClick={() => {
                        props.onFilter({
                          [`curriculum.${key}`]: props.currentFilters[`curriculum.${key}`]
                            ? false
                            : true,
                        })
                      }}
                    />
                  )}
                </Box>
              )
            })}
            {Object.keys(languages).map((key: any) => {
              return (
                <Box className={classes(mt8, mr8)} key={key}>
                  {props.filters?.languages.find((a: any) => a.name === key)?.label && (
                    <Button
                      size="xs"
                      icon={
                        <span
                          className={classes(
                            props.currentFilters?.[`languages.${key}`]
                              ? 'material-icons'
                              : 'material-icons-two-tone',
                            f12i,
                          )}
                        >
                          translate
                        </span>
                      }
                      label={props.filters?.languages.find((a: any) => a.name === key)?.label}
                      baseline={
                        props.currentFilters[`languages.${key}`] ? 'secondary' : 'background'
                      }
                      onClick={() => {
                        props.onFilter({
                          [`languages.${key}`]: props.currentFilters[`languages.${key}`]
                            ? false
                            : true,
                        })
                      }}
                    />
                  )}
                </Box>
              )
            })}
          </Box>
        </Box>
      )}
    </>
  )
}

const STYLES = stylesheet({
  containerAd: {
    overflow: 'hidden',
    transitionProperty: 'none',
  },
  containerDistance: {
    height: 28,
    minWidth: 40,
    paddingLeft: 6,
    paddingRight: 6,
  },
  containerFocused: {
    background: 'white',
    boxShadow: '0 0 0 2px #312c2c',
    zIndex: 2,
    borderRadius: important(8),
  },
  contaierChildcare: {
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    margin: '0 8px',
    padding: 8,
    position: 'relative',
  },
  containerAgeGroup: {
    alignItems: 'flex-end',
  },
  containerTags: {
    color: 'rgb(117, 129, 148)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    marginBottom: 4,
  },
  textAgeGroup: {
    textAlign: 'right',
  },
  textName: {
    width: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: '-webkit-box',
    $nest: {
      ...createCustomMediaQuery({
        maxWidth: 520,
        style: {
          overflow: 'initial',
          display: 'block',
        },
      }),
    },
  },
  divider: {
    borderColor: 'rgb(120,120,120)',
    width: '100%',
  },
})
